import React from 'react';
import PropTypes from 'prop-types';
import {StyledMissingFieldIndicator} from './StyledMissingFieldIndicator';

const MissingFieldIndicator = ({ size = 'small', title, ...rest }) => {
  return (
    <StyledMissingFieldIndicator
      aria-label={title || 'Missing field'}
      size={size}
      title={title || 'Field requires info'}
      {...rest}
    />
  );
};

MissingFieldIndicator.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  title: PropTypes.string,
};

export default MissingFieldIndicator;
